import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const ClientCtx = createContext(null);
export const useClients = () => useContext(ClientCtx);

export function ClientProvider({ children }) {
  const [clients, setClients] = useState([]);
  const [current, setCurrent] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const { data } = await api.get("/clients");
      setClients(data);
      setCurrent((c) => {
        if (c) { const found = data.find((x) => x.id === c.id); if (found) return found; }
        const saved = localStorage.getItem("scc_client");
        return data.find((x) => x.id === saved) || data[0] || null;
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const select = (client) => {
    setCurrent(client);
    if (client) localStorage.setItem("scc_client", client.id);
  };

  return (
    <ClientCtx.Provider value={{ clients, current, select, refresh, loading }}>
      {children}
    </ClientCtx.Provider>
  );
}
